"use client";

import { useUser } from "@clerk/nextjs";
import EmbedHeroSection from "./EmbedHeroSection";

export default function AuthAwareEmbedHero() {
  const { isSignedIn } = useUser();
  return <EmbedHeroSection isAuthenticated={Boolean(isSignedIn)} />;
}
